/**
 * Whether the integer part of a typed number (before the decimal comma or point) has more
 * digits than allowed, e.g. "1000" for at most 3 digits. Spaces and signs are not counted,
 * decimals are always allowed.
 */
const exceedsIntegerDigits = (
  value: string,
  maxIntegerDigits: number | undefined
): boolean => {
  if (maxIntegerDigits === undefined) {
    return false;
  }

  const integerPart = value.split(/[.,]/)[0].replace(/\D/g, '');
  return integerPart.length > maxIntegerDigits;
};

export default exceedsIntegerDigits;
